import { DepartmentEnum, type FileInputType, type PaginationInputType } from '@/gql/graphql';

export interface ListType<TId = number | string> {
  id?: TId;
  label: string;
  key: string | null;
  alias?: string;
  children?: ListType[];
  isHidden?: boolean;
  disabled?: boolean;
}

export interface FormListType {
  name: string;
  type: string;
  icon: string;
  path: string;
  id?: string;
  parentName: string;
  roles?: string[];
  searchKey?: string;
}

export interface PaginationType {
  offset: number;
  limit: number;
}

export interface LinkTextType {
  text: string;
  path?: string;
  roles?: string[];
}

export interface SidebarItemType {
  name: string;
  icon?: string;
  path?: string;
  roles?: string[];
  children?: SidebarItemType[];
  seperate?: boolean;
  isOnlyMenu?: boolean;
  description?: string;
  subItemList?: LinkTextType[];
  partnersToExclude?: string[];
}

export enum MEASUREMENT_SYSTEM {
  IMPERIAL = 'IMPERIAL',
  METRIC = 'METRIC',
}

export enum MEASUREMENT_UNITS {
  MILES = 'miles',
  KM = 'km',
}

export enum ServiceTypeEnum {
  Ride = 'ride',
  Grocery = 'grocery',
  Meal = 'meal',
  HomeService = 'homeService',
  Pharmacy = 'pharmacy',
  VirtualEvent = 'virtualEvent',
  Reimburse = 'reimburse',
  Other = 'other',
}

type AlreadyDiscussed = 'How GoGo works' | 'Membership Pricing' | 'Collected details for soft register';

export interface IRegistrationTransferNotes {
  title?: null | string;

  callNotes?: null | string;

  fromDepartment?: null | string | DepartmentEnum;

  alreadyDiscussed?: null | string[] | AlreadyDiscussed[];

  notesForOperator?: null | string;
}

export type FileInput = FileInputType;

export type PresignedUrl = {
  url: string;
  key: string;
  accessUrl?: string | null;
};

export type PaginationInput = PaginationInputType;

export enum PushNotificationCode {
  IncomingCall = 'incoming-call',
  DriverCanceled = 'driverCanceled',
  MaxDriverCancels = 'maxDriverCancels',
  ClientStripeError = 'client-stripe-error',
  ClientCardAdded = 'client-card-added',
  ClientCardLinkAccessed = 'client-card-link-accessed',
  ReservedOutboundCall = 'reserved-outbound-call',
  ReservedOutboundCallCancelled = 'reserved-outbound-call-cancelled',
  FollowUpCallStarted = 'follow-up-call-started',
  WelcomeTextInbox = 'welcome-text-inbox',
}

export enum YesNoEnum {
  Yes = 'Yes',
  No = 'No',
}
